interface KycConcentResponse {
  result?: KycConcentResult;
  success?: boolean;
}

const KycCommonErrorCodeList = [
  'kyc_already_completed',
  'user_not_found',
  'kyc_not_approved',
  'import_blocked_due_to_country',
  'missing_document',
] as const;

type KycCommonErrorCodes = (typeof KycCommonErrorCodeList)[number];

interface KycConcentError {
  code?: KycCommonErrorCodes;
  success?: boolean;
}

interface KycConcentResult {
  aadhaar_number?: string;
  first_name?: string;
  is_kyc_done?: boolean;
  last_name?: string;
  pan_number?: string;
}

interface KycConcentUpdateResponse {
  success?: boolean;
}

export type {
  KycConcentResult,
  KycConcentResponse,
  KycConcentError,
  KycConcentUpdateResponse,
  KycCommonErrorCodes,
};

export { KycCommonErrorCodeList };
